import useGetCountryFromUrl from '@fingo/lib/hooks/useGetCountryFromUrl';
import useSelectedCompany from '@fingo/lib/hooks/useSelectedCompany';
import { useTranslation } from 'react-i18next';
import {
  getDigitalCertificateCredentials,
  getSiiCredentials,
  getDocumentCredentials,
} from '@fingo/lib/helpers/profile/credentials';
import { REQUESTING_PLATFORM_TO_CODES } from '@fingo/lib/constants/requesting-platform';
import CREDENTIALS_REQUIRED_DOCUMENTS from '../constants/credentials-required-documents';

const useCompanyCredentials = () => {
  const selectedCompany = useSelectedCompany();
  const { t } = useTranslation();
  const country = useGetCountryFromUrl();
  const nationalTaxService = t('National Tax Service acronym');
  return [
    getSiiCredentials(selectedCompany, nationalTaxService, REQUESTING_PLATFORM_TO_CODES.ITAU),
    getDigitalCertificateCredentials(selectedCompany, nationalTaxService, country),
    ...CREDENTIALS_REQUIRED_DOCUMENTS.map((
      document,
    ) => getDocumentCredentials(selectedCompany, document, REQUESTING_PLATFORM_TO_CODES.ITAU)),
  ];
};

export default useCompanyCredentials;
